import { STORYBLOK_SLICES } from '~/lib/storyblok-types'

import PushTypeListing from '~/components/Slices/PushTypeListing'

export default {
  [STORYBLOK_SLICES.PUSH_DESIGNERS]: PushTypeListing,
}
